import Slice9Panel from "../../../../../shared/lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RichTextStyling from "../../../../../shared/src/ranj/app/ui/richtext/RichTextStyling";
import RichTextWrapper from "../../../../../shared/src/ranj/app/ui/richtext/RichTextWrapper";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ExampleItemView from "./ExampleItemView";
import SpotView from "./SpotView";

export default class LocationView extends AbstractView {

    constructor(target) {
        super(target);

        this._initFeedbackBalloon();
        this._sampleView = new ExampleItemView(this._target.textBalloon.fish);

        this._spots = [];
        this._spotsById = {};

        for (let i = 1; i < 99; i++) {
            let spotId = `spot${i}`;
            const spotMC = target[spotId];
            if (!spotMC) {
                break;
            }
            const spot = new SpotView(i, spotMC);

            this._spots.push(spot);
            this._spotsById[spotId] = spot;
        }

        this.setRule("");

        this._balloonPanelWidth = 0;
    }

    get spots() {
        return this._spots;
    }

    /**
     * @param {number} id
     * @returns {SpotView}
     **/
    getSpotById(id) {
        return this._spotsById[id];
    }

    get target() {
        return this._target;
    }

    destroy() {
        this._spots.forEach(spot => { spot.destroy(); });
        this._spots = null;
        this._spotsById = {};
    }

    showSolutionInfo(correctInput = null) {
        this._spots.forEach((spot, idx) => {
            let str = null;
            if (correctInput) {
                const spotIdx = idx + 1;
                const solutionIdx = correctInput?.indexOf(spotIdx);
                str = `#${spotIdx}`;
                if (solutionIdx > -1) {
                    str += `\n\n${solutionIdx + 1}`;
                } 
            }
            spot.setDebugInfo(str);
        });
    }

    setSample(skin) {
        this._sampleView.show(true);
        this._sampleView.content = skin;
    }

    _initFeedbackBalloon() {
        const balloon = this._target.textBalloon;
        const balloonBg = balloon.slicedPanel.children.find(c => c instanceof createjs.Bitmap);
        this._balloonSlicedPanel = new Slice9Panel(balloon.slicedPanel, balloonBg, { cacheBitmap: true, pixelPerfect: true, overlap: true, mode: Slice9Panel.VERTICAL })
        this._balloonSlicedPanel.update();
        
        balloon.slicedPanel.ruleLabelTextField.text = "";
        balloon.slicedPanel.shortRuleLabelTextField.text = "";
        this._ruleText = new RichTextWrapper(balloon.slicedPanel.ruleLabelTextField);
        this._ruleTextShort = new RichTextWrapper(balloon.slicedPanel.shortRuleLabelTextField);
    }

    /**
     * @param {string} text 
     * @param {boolean} isCorrect 
     */
    showFeedback(text, isCorrect) {
        this.setRule(text, false, isCorrect ? "correct" : "incorrect");
    }

    setRule(rule, useShortVariant = false, state = "normal") {
        const balloon = this._target.textBalloon;
        balloon.gotoAndStop(state);
        this._ruleText.text = "";
        this._ruleTextShort.text = "";
        if (useShortVariant) {
            this._ruleTextShort.text = rule;
            this._centerVertically(this._ruleTextShort, balloon.slicedPanel);
        } else {
            this._ruleText.text = rule;
            this._balloonSlicedPanel.update();
        }

        //Appear/disappear balloon?
        if (!this._rule && rule) {
            createjs.Tween.get(balloon).to({ alpha: 1 }, 300, createjs.Ease.quadIn);
        } else if (!rule) {
            createjs.Tween.get(balloon).to({ alpha: 0 }, 300, createjs.Ease.quadOut);
        }

        let profState = state;
        if (state == "normal") {
            profState = rule == null ? "neutral" : "open";
        }
        this._target.professor.gotoAndStop(profState);

        this._rule = rule;
    }

    _centerVertically(item, container) {
        const itemBounds = item.getBounds();
        const containerBounds = container.getBounds();
        if (itemBounds) {
            const y = containerBounds.y + (containerBounds.height - itemBounds.height) / 2;
            item.y = y;
        }
    }
}